import { StartApplicationAction, START_APPLICATION } from "./types";

export function startApplication(): StartApplicationAction {
    return { type: START_APPLICATION };
}